import { useEffect } from "react";
import { SAUNA_ORIGIN, saunaSchemas, type SaunaSeoPage } from "@/data/sauna-seo";

export function useSaunaSeo(page: SaunaSeoPage) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = page.title;
    const removed = [...document.head.querySelectorAll('meta[name="description"],meta[name="robots"],meta[name^="twitter:"],meta[property^="og:"],link[rel="canonical"],script[type="application/ld+json"]')];
    removed.forEach(node => node.remove());
    const added: Element[] = [];
    const add = (tag: string, attrs: Record<string, string>, text?: string) => {
      const node = document.createElement(tag);
      Object.entries(attrs).forEach(([key, value]) => node.setAttribute(key, value));
      if (text) node.textContent = text;
      document.head.appendChild(node);
      added.push(node);
    };
    const url = SAUNA_ORIGIN + page.path;
    add("link", { rel: "canonical", href: url });
    for (const [name, content] of Object.entries({
      description: page.description, robots: "index, follow, max-image-preview:large",
      "twitter:card": "summary_large_image", "twitter:title": page.title,
      "twitter:description": page.description, "twitter:image": `${SAUNA_ORIGIN}/images/${page.image}`,
    })) add("meta", { name, content });
    for (const [property, content] of Object.entries({
      "og:title": page.title, "og:description": page.description, "og:url": url,
      "og:type": page.kind === "article" ? "article" : "website",
      "og:image": `${SAUNA_ORIGIN}/images/${page.image}`, "og:locale": "en_GB",
    })) add("meta", { property, content });
    saunaSchemas(page).forEach(schema => add("script", { type: "application/ld+json" }, JSON.stringify(schema)));
    return () => {
      added.forEach(node => node.remove());
      removed.forEach(node => document.head.appendChild(node));
      document.title = previousTitle;
    };
  }, [page]);
}
